module.exports = __webpack_public_path__ + "img/chip.743f5747.png";